"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../../services/images");
const react_i18next_1 = require("react-i18next");
const SeatsPriceRowWeb = ({ availableSeats, price }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: "overview" });
    let seats = `${availableSeats} ${t("seats")}`;
    if (availableSeats < 2) {
        seats = `${availableSeats} ${t("seat")}`;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "divided-row", children: [(0, jsx_runtime_1.jsx)("div", { className: "box-narrow", children: (0, jsx_runtime_1.jsxs)("p", { className: "font-14-400 iconed", children: [(0, jsx_runtime_1.jsx)("img", { src: images_1.icons.PriceCircled, alt: "" }), price.toFixed(2), " z\u0142"] }) }), (0, jsx_runtime_1.jsx)("div", { className: "box-narrow", children: (0, jsx_runtime_1.jsxs)("p", { className: "font-14-400 iconed", children: [(0, jsx_runtime_1.jsx)("img", { src: images_1.icons.SeatsLeftCircled, alt: "" }), seats] }) })] }));
};
exports.default = SeatsPriceRowWeb;
